import { useTranslation } from "react-i18next";

import type { TransactionHistorySearchSchema } from "@/routes/transaction-history";

type SortByOptions = {
  value: TransactionHistorySearchSchema["sort"];
  label: string;
};

export const useTransactionHistorySortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("order", {
    keyPrefix: "transactionHistoryPage.filters.sortByOptions"
  });

  return [
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    }
  ];
};
